import api from './api'
import { EventoAuditoria, AuditoriaFiltros } from '@/types/auditoria'
import { PageResponse } from '@/types/comum'

const BASE_URL = '/api/v1/auditoria'

export const auditoriaService = {
  listar: async (filtros: AuditoriaFiltros = {}): Promise<PageResponse<EventoAuditoria>> => {
    const sp = new URLSearchParams()
    sp.append('page', String(filtros.page ?? 0))
    sp.append('size', String(filtros.size ?? 50))
    sp.append('sort', 'ocorridoEm,desc')
    if (filtros.modulo) sp.append('modulo', filtros.modulo)
    if (filtros.recurso) sp.append('recurso', filtros.recurso)
    if (filtros.recursoId) sp.append('recursoId', filtros.recursoId)
    if (filtros.acao) sp.append('acao', filtros.acao)
    if (filtros.usuarioId) sp.append('usuarioId', filtros.usuarioId)
    if (filtros.inicio) sp.append('inicio', filtros.inicio)
    if (filtros.fim) sp.append('fim', filtros.fim)
    const response = await api.get<PageResponse<EventoAuditoria>>(`${BASE_URL}?${sp.toString()}`)
    return response as unknown as PageResponse<EventoAuditoria>
  },

  obter: async (id: string): Promise<EventoAuditoria> => {
    const response = await api.get<EventoAuditoria>(`${BASE_URL}/${id}`)
    return response as unknown as EventoAuditoria
  },

  exportarCsv: async (filtros: AuditoriaFiltros = {}): Promise<Blob> => {
    const sp = new URLSearchParams()
    sp.append('limite', String(filtros.size ?? 10000))
    if (filtros.modulo) sp.append('modulo', filtros.modulo)
    if (filtros.recurso) sp.append('recurso', filtros.recurso)
    if (filtros.recursoId) sp.append('recursoId', filtros.recursoId)
    if (filtros.acao) sp.append('acao', filtros.acao)
    if (filtros.usuarioId) sp.append('usuarioId', filtros.usuarioId)
    if (filtros.inicio) sp.append('inicio', filtros.inicio)
    if (filtros.fim) sp.append('fim', filtros.fim)
    const response = await api.get(`${BASE_URL}/export.csv?${sp.toString()}`, {
      responseType: 'blob',
    })
    return response as unknown as Blob
  },
}
